import { asArray, isRealDate } from './promoPrimitives';
import { getOfferInfo } from './promoModel';
import { viewLevels } from './promoPhase';
import { getOfferForecastState, isLocalForecastNego, isPointsValidationBlocked } from './promoForecast';

// Points context of an offer (#23521), consumed by `OfferPointsBanner` / `PointsClaimButton`. Port of
// `getOfferPointsContext` (visitStep3-promo.js:1157-1230) : the claim key is appointmentUid / campaignId / offerId.

const iso = (value) => (isRealDate(value) ? new Date(value).toISOString() : null);

export function buildOfferPointsContext(snapshot, campaign, campaignOfferId, offerKey = null) {
	const levels = viewLevels(snapshot, campaign, offerKey);
	const forecastNego = isLocalForecastNego(snapshot, campaign, { campaignId: campaign.id, campaignOfferId, offerKey });
	const inNego = forecastNego || levels.nego > 0;
	const inStore = !forecastNego && levels.store > 0;
	const isLocal = !!campaign.promoLocal;
	const offerInfo = isLocal ? getOfferInfo(snapshot, offerKey) : null;

	let rows;
	if (isLocal) rows = asArray(inNego ? offerInfo?._negociatedCampaignOffers : offerInfo?._statedCampaignOffers);
	else rows = asArray(inNego ? snapshot?.model?.negotiated : snapshot?.model?.stated).filter((row) => row.campaignId === campaign.id && row.campaignOfferId === campaignOfferId);

	let start = null;
	let end = null;
	if (isLocal) {
		start = iso(offerInfo?.startDate);
		end = iso(offerInfo?.endDate);
	} else if (inNego) {
		start = iso(campaign.dates?.negoStart);
		end = iso(campaign.dates?.negoEnd);
	} else {
		start = iso(campaign.dates?.storeBegin);
		end = iso(campaign.dates?.storeEnd);
	}

	return {
		promoId: campaign.id,
		campaignId: campaign.id,
		offerId: campaignOfferId,
		appointmentUid: snapshot?.appointment?.uid ?? null,
		deliveryLocationId: snapshot?.appointment?.deliveryLocationId ?? null,
		scoringEnabled: (inNego && !!campaign.pointsNegotiationActive) || (inStore && !!campaign.pointsStatementActive),
		readonly: !!(snapshot?.consultation || snapshot?.readonly),
		forecastActive: isPointsValidationBlocked(getOfferForecastState(snapshot, campaign, { campaignId: campaign.id, campaignOfferId, offerKey })),
		campaignOfferStartDate: start,
		campaignOfferEndDate: end,
		promoData: {
			promoName: campaign.label || '',
			volumeUC: rows.reduce((acc, row) => acc + (row.volumeUC || 0), 0),
			meaCount: rows.filter((row) => (row.locationPromoId || 0) > 0 || (row.locationHighlightId || 0) > 0).length,
			presentCount: inNego ? 0 : rows.filter((row) => row.present === 1).length,
		},
	};
}
